import React, { useEffect, useState } from 'react';
import {
  Box, SimpleGrid, Stat, StatLabel, StatNumber, Text,
  Flex, Card, CardBody, Spinner,
} from '@chakra-ui/react';
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import axios from 'axios';

const DashboardDivisionTerrenos = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/solicitud-division-terrenos`)
      .then(res => setData(res.data))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner size="xl" color="blue.500" />;

  const total = data.length;

  const tiposOperacion = data.reduce((acc: any, item) => {
    const tipo = item.tipoOperacion || 'Desconocido';
    acc[tipo] = (acc[tipo] || 0) + 1;
    return acc;
  }, {});

  const totalIngreso = data.reduce((acc, item) => acc + (item.costo || 0), 0);
  const fraccionesTotales = data.reduce((acc, item) => acc + (item.fracciones || 0), 0);

  const chartData = Object.entries(tiposOperacion).map(([name, value]) => ({ name, value }));
  const colors = ['#38A169', '#3182CE', '#DD6B20', '#D53F8C', '#718096'];

  return (
    <Box p={6}>
<Flex justify="center" mb={6}>        {/* Métricas */}
       

        {/* Gráfica de tipos */}
        <Card flexBasis={{ base: '100%', md: '400px' }} boxShadow="none">
          <CardBody>
            <Text fontWeight="bold" mb={4} textAlign="center">
              Tipos de Operación
            </Text>
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={chartData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  label
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </CardBody>
        </Card>
      </Flex>
      <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4} flex={1}>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Total de Solicitudes</StatLabel>
            <StatNumber>{total}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Fracciones Totales</StatLabel>
            <StatNumber>{fraccionesTotales}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Ingresos Generados</StatLabel>
            <StatNumber>${Number(totalIngreso).toFixed(2)}</StatNumber>
          </Stat>
        </SimpleGrid>
    </Box>
  );
};

export default DashboardDivisionTerrenos;
